import { Suspense, ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const queryClient = new QueryClient();

interface LayoutProps {
  children?: ReactNode;
}

/**
 * Site shell: navigation, footer and the persistent contact affordances.
 *
 * Navbar and Footer belong HERE rather than in each page. They were previously
 * rendered only by Index.tsx and a couple of landing pages, which meant every
 * other route prerendered with no <nav> and no <footer> at all — no site
 * navigation, and no internal links out. That is what left /contact reachable
 * from nowhere but the sitemap, and it would have silently orphaned all ~40
 * pages of the new bilingual service/doctor/case architecture.
 *
 * Because Navbar/Footer read the active locale from context, mounting them once
 * here also guarantees every page's navigation stays inside the visitor's
 * language.
 */
const Layout = ({ children }: LayoutProps) => (
  <QueryClientProvider client={queryClient}>
    <Toaster />
    <Navbar />
    <Suspense fallback={null}>
      {children ?? <Outlet />}
    </Suspense>
    <Footer />
    <FloatingWhatsApp />
  </QueryClientProvider>
);

export default Layout;
